import { Modal, ModalBody } from "reactstrap";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { useEffect, useState } from "react";
import { useSkillsAction } from "../../../../services/actions/skills.action";
import { HiMagnifyingGlass } from "react-icons/hi2";
import ColorsCircles from "./colors-roles";
import { v4 as uuidv4 } from "uuid";
import { useChargesAction } from "../../../../services/actions/charges.action";
import toast from "react-hot-toast";
import { normalizeString } from "../../../../helpers/functions";

const CreateChargesModal = (props) => {
  const { open, toggle, update, currentClientsId, superAdmin } = props;
  const { createCharge } = useChargesAction();
  const { listSkills } = useSkillsAction();
  const [skillList, setListSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [showSkills, setShowSkills] = useState(false);

  useEffect(() => {
    const getSkills = async () => {
      const { data } = await listSkills();

      const sortSkills = data.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
      setListSkills(data);
      setFilteredSkills(sortSkills);
    };
    getSkills();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFilteredSkills(
      skillList.filter((skill) =>
        normalizeString(skill.name)
          .toLowerCase()
          .includes(normalizeString(searchTerm).toLowerCase())
      )
    );
  }, [searchTerm, skillList]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let newData = Object.fromEntries(data.entries());
    let competences = selectedSkills.map((skill) => skill.id);
    newData = {
      ...newData,
      id: uuidv4(),
      type: "",
      competences,
      currentClientsId: superAdmin ? "" : currentClientsId,
    };

    createCharge(newData, () => {
      toast.success("Cargo creado exitosamente", { duration: 4000 });
      toggle();
      update();
    });
  };

  const handleSelectSkill = (skill) => {
    if (!selectedSkills.find((selected) => selected.id === skill.id)) {
      setSelectedSkills((prevValues) => [...prevValues, skill]);
    }
  };

  const handleDeleteSkill = (skill) => {
    setSelectedSkills(selectedSkills.filter((skills) => skills.id !== skill));
  };

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setShowSkills(false);
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Crear Cargo</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">Nombre</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    maxLength={150}
                  />
                </div>
              </div>
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="description">Descripción</label>
                  <textarea
                    type="text"
                    id="description"
                    name="description"
                    required
                    maxLength={2000}
                  />
                </div>
              </div>
              <div className="gm-modal-searchbar-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="skill-search">
                    Competencias: selecciona mínimo 3 y máximo 7 de la lista.{" "}
                  </label>
                  <div
                    className="gm-modal-input-group"
                    onFocus={() => setShowSkills(true)}
                    onBlur={handleBlur}
                    tabIndex={-1}
                  >
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Buscar Competencia"
                      onClick={() => setShowSkills(true)}
                    />
                    {HiMagnifyingGlass}

                    <ul>
                      {showSkills &&
                        filteredSkills.map((skill) => (
                          <li
                            className="gm-modal-li-searchbar"
                            key={skill.id}
                            onClick={() => handleSelectSkill(skill)}
                          >
                            {skill.name}{" "}
                            <div>
                              {skill.colorType.map((element) => (
                                <ColorsCircles colors={element} />
                              ))}
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                <div className="gm-modal-form-group">
                  <div className="gm-modal-input-group">
                    <label>
                      Competencias seleccionadas ({selectedSkills.length}):{" "}
                    </label>
                    <div className="gm-modal-group-selected">
                      {selectedSkills.map((skills) => (
                        <div key={skills.id}>
                          {" "}
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => {
                              handleDeleteSkill(skills.id);
                            }}
                          />
                          <span> {skills.name}</span>{" "}
                          <div>
                            {skills.colorType.map((colors) => (
                              <ColorsCircles colors={colors} />
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="gm-modal-buttons">
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Crear"
              disabled={selectedSkills.length < 3 || selectedSkills.length > 7}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default CreateChargesModal;